export default __webpack_public_path__ + "images/75d81eed66f040a590ed5744b3367d8c-music.webp";